import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { useNotif } from '../context/NotifContext';
import './Topbar.css';

const MoonIcon = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>;
const SunIcon  = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>;

const NOTIF_ICONS = {
  lead:    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>,
  invoice: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/></svg>,
  project: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  team:    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>,
  reminder:<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
};
const ROLE_COLOR  = { 'Super Admin':'#F5A623', 'Admin':'#3B82F6', 'User':'#22C55E' };

function NotifPanel({ notifs, markRead, markAll, onClose, theme }) {
  return (
    <div className="tb-notif-panel" data-theme={theme}>
      <div className="tb-np-hd">
        <span className="tb-np-title">Notifications</span>
        <span className="tb-np-clear" onClick={markAll}>Mark all read</span>
      </div>
      <div className="tb-np-list">
        {notifs.map(n => (
          <div key={n.id} className={`tb-np-item${n.read?'':' unread'}`} onClick={()=>markRead(n.id)}>
            <span className="tb-np-icon">{NOTIF_ICONS[n.type]||'📌'}</span>
            <div className="tb-np-body">
              <div className="tb-np-text">{n.text}</div>
              <div className="tb-np-time">{n.time}</div>
            </div>
            {!n.read && <div className="tb-np-dot"/>}
          </div>
        ))}
      </div>
    </div>
  );
}

function ProfilePanel({ user, theme, onClose, navigate, logout }) {
  const SettIcon = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>;
  const UserIcon = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>;
  const BellIcon = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>;
  const SignIcon = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>;
  return (
    <div className="tb-profile-panel" data-theme={theme}>
      <div className="tb-pp-top">
        <div className="tb-pp-av" style={{background:`${ROLE_COLOR[user.role]}22`,color:ROLE_COLOR[user.role]}}>{user.initials}</div>
        <div>
          <div className="tb-pp-name">{user.name}</div>
          <div className="tb-pp-email">{user.email}</div>
          <div className="tb-pp-role" style={{color:ROLE_COLOR[user.role]}}>{user.role}</div>
        </div>
      </div>
      <div className="tb-pp-divider"/>
      {[
        { icon:<SettIcon/>, label:'Settings',           action:()=>{ navigate('/settings?tab=Company'); onClose(); } },
        { icon:<UserIcon/>, label:'My Profile',         action:()=>{ navigate('/settings?tab=Profile'); onClose(); } },
        { icon:<BellIcon/>, label:'Notification Prefs', action:()=>{ navigate('/settings?tab=Notifications'); onClose(); } },
        { icon:<SignIcon/>, label:'Sign Out', action:()=>{ logout(); onClose(); }, red:true },
      ].map(item => (
        <div key={item.label} className={`tb-pp-item${item.red?' red':''}`} onClick={item.action}>
          <span className="tb-pp-item-icon">{item.icon}</span>
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
}

export default function Topbar({ title, subtitle, actions }) {
  const { theme, toggle } = useTheme();
  const { user, logout }  = useAuth();
  const { notifs, markRead, markAll, unread } = useNotif();
  const navigate          = useNavigate();
  const isDark            = theme === 'dark';

  const [showNotif,   setShowNotif]   = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const notifRef   = useRef(null);
  const profileRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (notifRef.current   && !notifRef.current.contains(e.target))   setShowNotif(false);
      if (profileRef.current && !profileRef.current.contains(e.target)) setShowProfile(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="topbar" data-theme={theme}>
      <div className="topbar-left">
        {title    && <div className="topbar-title">{title}</div>}
        {subtitle && <div className="topbar-sub">{subtitle}</div>}
      </div>
      {actions && <div className="topbar-actions">{actions}</div>}
      <div className="topbar-utils">
        <div className="tog" onClick={toggle} data-theme={theme}>
          <span className="tog-icon">{isDark ? <MoonIcon/> : <SunIcon/>}</span>
          <div className="tog-track"><div className={`tog-knob${isDark?'':' on'}`}/></div>
          <span className="tog-lbl">{isDark ? 'Dark' : 'Light'}</span>
        </div>
        {/* Bell */}
        <div ref={notifRef} style={{position:'relative'}}>
          <div className="tb-bell" data-theme={theme} onClick={()=>{ setShowNotif(s=>!s); setShowProfile(false); }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
            {unread > 0 && <div className="tb-bell-dot">{unread > 9 ? '9+' : unread}</div>}
          </div>
          {showNotif && <NotifPanel notifs={notifs} markRead={markRead} markAll={markAll} onClose={()=>setShowNotif(false)} theme={theme}/>}
        </div>
        {/* Avatar */}
        <div ref={profileRef} style={{position:'relative'}}>
          <div className="tb-av" data-theme={theme} onClick={()=>{ setShowProfile(s=>!s); setShowNotif(false); }}>{user.initials}</div>
          {showProfile && <ProfilePanel user={user} theme={theme} onClose={()=>setShowProfile(false)} navigate={navigate} logout={logout}/>}
        </div>
      </div>
    </div>
  );
}
